import logger from '@greenlight/logger';

const promiseMiddleware = store => next => action => {
  // check if it has a promise
  if (!action.promise || typeof action.promise.then !== 'function')
    return next(action);

  next({ type: `${action.type}_LOADING` });

  action.promise
    .then(payload =>
      next({
        type: `${action.type}_SUCCESS`,
        payload,
        originalQuestionsAndAnswer: action.originalQuestionsAndAnswer,
        extras: action.extras
      })
    )
    .catch(err => {
      logger.error(err);
      if (action.type !== 'GET_BANK_NAME') {
        window.scrollTo(0, 0);
      }
      next({
        type: `${action.type}_FAILURE`,
        error: err,
        payload: { error: err },
        originalQuestionsAndAnswer: action.originalQuestionsAndAnswer,
        extras: action.extras
      });
    });
};
export default promiseMiddleware;
